export default {
  potentialCustomer: '意向客',
  frequentVisitor: '回头客',
  arrivalStore: '到店门店',
  arrivalStoreWithColon: '到店门店：',
  remindersForPotentialCustomer: '意向客到店提醒',
  remindersForFrequentVisitor: '回头客到店提醒',
  YearsOld: '{num}岁',
  arrivalTime: '到店时间',
  arrivalTimeWithColon: '到店时间：',
  customerTag: '顾客标签',
  memberTag: '会员标签',
  recentConsumption: '最近消费',
  recentConsumptionWithColon: '最近消费：',
  customerArrivalReminder: '顾客到店提醒',
  yuan: '元',
  week: '周',
  comma: '，',
  timeActuallyTook: '实际耗时',
  d: '{d}天',
  h: '{h}小时',
  m: '{m}分钟',
  underOneM: '<1分钟',
  noInstallationPackageToDownloadPleaseContactAdministrator: '无安装文件可下载，请联系系统管理员。',
  Confirm: '确认'
}
